// @ts-strict-ignore
import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { SelectModule } from "primeng/select";
import { TableModule } from "primeng/table";
import { ErrorCheck } from "src/app/shared/models/error-check.model";
import { ProgressCheck } from "src/app/shared/models/progress-check.model";
import { SharedDirectivesModule } from "src/app/shared/shared-directives.module";
import * as C from "../../../../../../shared/constants/globals.constants";
import { EWizDynamicBaseClassComponent } from "src/app/modules/esim/shared/classes/ewiz-dynamic.class";
import { DataService } from "src/app/shared/services/data.service";
import * as ProfileModel from "src/app/shared/models/profile.model";
import { ErrorMessageComponent } from "src/app/modules/esim/shared/components/error-message/error-message.component";

@Component({
  selector: C.EWIZ_EMERGENCY_CALL_CODES_CONFIGURATION,
  templateUrl: "./emergency-call-codes-configuration.component.html",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    InputTextModule,
    SelectModule,
    TableModule,
    SharedDirectivesModule,
    ErrorMessageComponent
  ]
})
export class EWizEmergencyCallCodesConfigurationComponent
  extends EWizDynamicBaseClassComponent
  implements OnInit, ErrorCheck, ProgressCheck
{
  constructor() {
    super();

    this.emergencyServiceCategoryOptions = [
      { label: $localize`NOT SET`, value: "0" },
      { label: $localize`Police`, value: "1" },
      { label: $localize`Ambulance`, value: "2" },
      { label: $localize`Fire Brigade`, value: "3" },
      { label: $localize`Marine Guard`, value: "4" },
      { label: $localize`Mountain Rescue`, value: "5" }
    ];
  }

  selectedCallCodes: ProfileModel.EmergencyCallCodesDto[] | null = null;
  nextId = 0;
  emergencyServiceCategoryOptions = [];

  ngOnInit() {
    this.handleFormEvents();

    this.errorCheck(this.profileValues);

    if (this.profileValues.emergencyCallCodes.length > 0) {
      for (const callCode of this.profileValues.emergencyCallCodes) {
        if (callCode.id > this.nextId) {
          this.nextId = callCode.id;
        }
      }
    }
  }

  errorCheck(values: ProfileModel.ProfileDto) {
    // Always reset error values to default state prior to executing check
    this.errorFound = false;
    this.errorMessage = "";

    if (values.emergencyCallCodes) {
      for (const callCode of values.emergencyCallCodes) {
        if (callCode.callCode) {
          if (callCode.callCode.length < 3 || callCode.callCode.length > 6) {
            this.errorMessage = $localize`Emergency Call Codes must be between 3 and 6 digits`;
            this.errorFound = true;
          }
        }
      }
    }

    return this.errorFound;
  }

  progressCheck(values: ProfileModel.ProfileDto, dataService: DataService) {
    if (values.emergencyCallCodes) {
      for (const callCode of values.emergencyCallCodes) {
        if (dataService.isNullOrEmpty(callCode.callCode)) {
          return false;
        }
        if (callCode.serviceCategory === null) {
          return false;
        }
      }
    } else {
      return false;
    }

    return true;
  }

  addEmergencyCallCode() {
    const newEmergencyCallCodes = [...this.profileValues.emergencyCallCodes];

    newEmergencyCallCodes.push({
      id: ++this.nextId,
      callCode: "",
      serviceCategory: this.emergencyServiceCategoryOptions[0]
    });

    this.profileValues.emergencyCallCodes = [...newEmergencyCallCodes];

    this.handleFormEvents();
  }

  deleteEmergencyCallCodes() {
    const newEmergencyCallCodes = [];

    for (const originalCallCode of this.profileValues.emergencyCallCodes) {
      let removeCallCode = false;

      for (const selectedCallCode of this.selectedCallCodes) {
        if (originalCallCode.id === selectedCallCode.id) {
          removeCallCode = true;
          break;
        }
      }

      if (!removeCallCode) {
        newEmergencyCallCodes.push(originalCallCode);
      }
    }

    this.profileValues.emergencyCallCodes = [...newEmergencyCallCodes];
    this.selectedCallCodes = [];

    this.handleFormEvents();
  }
}
